import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

enum DialogState {
  Open,
  Close,
  Dismiss
}
interface IDialogState {
  rendaringName: string;
  dialogState: DialogState;
  data?: any;
  disableClose?: boolean;
  errorMessage: string;
}

@Injectable({
  providedIn: 'root'
})
export class DialogStateService {
  private dialogState: Subject<any>;
  private dialogObservables: { [key: string]: any } = {};
  private dialogIDs: string[] = [];

  constructor(router: Router) {
    this.dialogState = new Subject<any>();

    router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.dialogIDs = [];
      });
  }

  getDialogState() {
    return this.dialogState.asObservable();
  }

  addDialogId(id: string) {
    this.dialogIDs.push(id);
  }

  checkIfPopupExists(id: string) {
    return this.dialogIDs.indexOf(id) !== -1;
  }

  updateDialogState(
    rendaringName: string,
    data: any,
    dialogState: DialogState,
    disableClose?: boolean
  ) {
    this.dialogState.next(<IDialogState>{
      rendaringName: rendaringName,
      dialogState: dialogState,
      data,
      disableClose
    });
  }

  openDialog(
    rendaringName: string,
    data?: any,
    disableClose?: boolean
  ): Observable<any> {
    this.dialogState.next(<IDialogState>{
      rendaringName: rendaringName,
      dialogState: DialogState.Open,
      data,
      disableClose
    });

    return Observable.create(observer => {
      this.dialogObservables[rendaringName] = observer;
    });
  }

  updateDialogWithError(
    rendaringName: string,
    data?: any,
    disableClose?: boolean,
    errorMessage?: string
  ): Observable<any> {
    data.errorMessage = errorMessage;
    this.dialogState.next(<IDialogState>{
      rendaringName: rendaringName,
      dialogState: DialogState.Open,
      data,
      disableClose
    });
    return Observable.create(observer => {
      this.dialogObservables[rendaringName] = observer;
    });
  }

  closeDialog(rendaringName: string) {
    this.dialogState.next(<IDialogState>{
      rendaringName: rendaringName,
      dialogState: DialogState.Close
    });
  }

  closeDialogByReference(rendaringName: string, data?: any) {
    if (this.dialogObservables[rendaringName]) {
      this.dialogObservables[rendaringName].next(data);
      delete this.dialogObservables[rendaringName];
    }
  }
}

export { IDialogState, DialogState };
